import { getStylesArrayWithoutSpaces } from '../helpers';

export interface TextFieldsEditableData {
	fontFamilies: Set<string>;
	fontSizes: Set<string>;
	colors: Set<string>;
	lineHeights: Set<string>;
	letterSpacings: Set<string>;
}

// Define used styles in editable text fields to use them in RichTextEditor toolbar
export const addStylesToEditableTextFieldsData = (data: TextFieldsEditableData, stylesString: string): void => {
	const dataKeys = {
		'font-family': 'fontFamilies',
		'font-size': 'fontSizes',
		color: 'colors',
		'line-height': 'lineHeights',
		'letter-spacing': 'letterSpacings',
	};

	const stylesArray = getStylesArrayWithoutSpaces(stylesString).filter((style) => {
		const styleName = style.split(':')[0];
		return Object.keys(dataKeys).includes(styleName);
	});

	stylesArray.forEach((style) => {
		const [key, value] = style.split(':');
		data[dataKeys[key]].add(value);
	});
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableTextFields/textFieldsEditableData.ts